export enum SystemPart {
    BROKER = 'BROKER',
    EXCHANGE = 'EXCHANGE'
}
